/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@thinglogix/ngx-foundry-core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MD5 } from 'crypto-js';
import { LiValidators } from 'src/app/shared/forms/validators';

@Component({
    selector: 'li-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.sass'],
})
export class ResetPasswordComponent implements OnDestroy {
    userId = '';

    isLoader = false;

    sucessClass = '';

    token = '';

    sucessClassAdd = '';

    account = '';

    CurrentState: any;

    errorMsg = '';

    resetForm: FormGroup = this.fb.group(
        {
            password: ['', [Validators.required, Validators.minLength(8)]],
            confirm_password: [
                '',
                [Validators.required, Validators.minLength(8)],
            ],
        },
        {
            validator: LiValidators.mustMatch('password', 'confirm_password'),
        }
    );

    private ngUnsubscribe = new Subject();

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private authService: AuthService
    ) {
        this.route.queryParams.subscribe((queryParams) => {
            this.userId = queryParams['user_id'];
            this.token = queryParams['token'];
            this.account = queryParams['account_id'];
            //  this.authorize = queryParams.authorize;
        });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(undefined);
        this.ngUnsubscribe.complete();
    }

    /**
     * Calls the reset password API using the form value
     *
     * @returns {Promise<void>} Promise with void value after the API has been called
     */
    async reset(): Promise<void> {
        const password: string = this.resetForm.value.password.trim();
        const passwordMD5: string = MD5(password).toString();
        this.isLoader = true;
        this.authService.checkResetPassword(
            this.account,
            this.userId,
            this.token
        );
        this.errorMsg = '';
        this.authService
            .setNewPassword(this.account, this.userId, this.token, passwordMD5)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                () => {
                    this.isLoader = false;
                    this.sucessClass = 'tabcontentRemove';
                    this.sucessClassAdd = 'tabcontentadd';
                },
                (error: any) => {
                    this.isLoader = false;
                    this.errorMsg = error.error.error;
                }
            );
    }
}
